/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestConnectionResultDto } from '../../models/test-connection-result-dto';

export interface DatasourcesDataSourceIdTestPost$Plain$Params {
  dataSourceId: string;
}

export function datasourcesDataSourceIdTestPost$Plain(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdTestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdTestPost$Plain.PATH, 'post');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestConnectionResultDto>;
    })
  );
}

datasourcesDataSourceIdTestPost$Plain.PATH = '/datasources/{dataSourceId}/test';
